import { render, staticRenderFns } from "./CardMaterials.vue?vue&type=template&id=1282579c&"
import script from "./CardMaterials.vue?vue&type=script&lang=js&"
export * from "./CardMaterials.vue?vue&type=script&lang=js&"
import style0 from "./CardMaterials.vue?vue&type=style&index=0&id=1282579c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports